// extracted by mini-css-extract-plugin
export default {"slides_box":"index_slides_box_1Px-P","tip":"index_tip_AbSG6"};